import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PagePanel,
  Button,
  ButtonMode,
  Box,
  InProgressIcon,
  CircleSuccessIcon
} from 'edenred-ui';
import { useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';

import { EmptyState } from '@epi-shared/components';
import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { clearFee, loadCompanyAccounts } from '@epi-actions/api';
import { ITopupInProgress } from '@epi-models/pages/TransferPage';
import { useGetMetadataQuery } from '@epi-api/companyMetadata';

export const TopupInProgress = ({
  setShowTopupForm,
  isTopupProcessing,
  summaryId,
  loadableBenefits,
  setForceUpdate
}: ITopupInProgress) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { reset } = useFormContext();
  const { refetch: refetchCompanyMetadata } = useGetMetadataQuery();

  const goToReports = () => {
    dispatch(
      goToPage(
        summaryId
          ? `${routerPaths.reportsTopups}/${summaryId}`
          : routerPaths.reports
      )
    );
  };

  const handleAnotherTopup = () => {
    refetchCompanyMetadata();
    if (loadableBenefits?.length > 1) dispatch(clearFee());
    setShowTopupForm(true);
    setForceUpdate(true);
    reset();
  };

  useEffect(() => {
    if (!isTopupProcessing) {
      dispatch(loadCompanyAccounts());
    }
  }, [isTopupProcessing]);

  return (
    <Box>
      <PagePanel>
        <Box
          mt={6}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <EmptyState
            icon={
              isTopupProcessing ? <InProgressIcon /> : <CircleSuccessIcon />
            }
            title={
              isTopupProcessing
                ? t(
                    'containers.deposit_money.topup_tab.topup_in_progress.in_progress'
                  )
                : t(
                    'containers.deposit_money.topup_tab.topup_in_progress.completed'
                  )
            }
            btnText={t(
              'containers.deposit_money.topup_tab.topup_in_progress.add_another'
            )}
            btnOnClick={handleAnotherTopup}
            btnDisabled={isTopupProcessing}
          />
          <Box mt={4}>
            <Button
              mode={ButtonMode.Link}
              onClick={goToReports}
              id="topup_report"
            >
              {t(
                'containers.deposit_money.topup_tab.topup_in_progress.see_report'
              )}
            </Button>
          </Box>
        </Box>
      </PagePanel>
    </Box>
  );
};
